import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getChildbirthOBSelector } from '../selectors'
import { ChildbirthOBConstants } from '../store/childbirthOB.constants'
import { IChildbirthOBState } from '../store/childbirthOB.types'

export function* setProcedureComplications() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const childbirthOBState: IChildbirthOBState = yield select(getChildbirthOBSelector)
  const { inputRows } = procedureState
  const { procedureComplications } = childbirthOBState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === ChildbirthOBConstants.SET_PROCEDURE_COMPLICATIONS) {
        //@ts-ignore
        input.props.savedValues = procedureComplications
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setProcedureComplicationsSaga() {
  yield takeLatest([ChildbirthOBConstants.SET_PROCEDURE_COMPLICATIONS], setProcedureComplications)
}
